import { blockModClassName } from './block-mod-class-name.js';
import { elemClassName } from './elem-class-name.js';
import { elemModClassName } from './elem-mod-class-name.js';
import type { ClassNameList, ModsList } from './types.js';

export interface ClassNameProps {
    className?: string;
}

type BlockArgs = [];
type BlockModArgs = [ModsList?, ClassNameList?];
type ElemArgs = [string, ClassNameList?];
type ElemModArgs = [string, ModsList?, ClassNameList?];

export type FormatterArgs = BlockArgs | BlockModArgs | ElemArgs | ElemModArgs;

export type cnFormatter = (...args: FormatterArgs) => string;
export type cnFunction = (blockName: string) => cnFormatter;

const isBlockModCall = (args: FormatterArgs): args is BlockModArgs =>
    typeof args[0] === 'object' || (typeof args[0] === 'undefined' && Array.isArray(args[1]));

const isElemArgs = (args: FormatterArgs): args is ElemArgs =>
    (typeof args[0] === 'string' && args[0] !== '' && typeof args[1] !== 'object') || Array.isArray(args[1]);

const isElemModArgs = (args: FormatterArgs): args is ElemModArgs =>
    typeof args[0] === 'string' && typeof args[1] === 'object' && !Array.isArray(args[1]);

export const cn: cnFunction =
    (blockName) =>
    (...args) => {
        if (isBlockModCall(args)) {
            const [mods, mix] = args;

            const classList = [blockName];

            if (mods) {
                Object.entries(mods).forEach(([modName, modValue]) => {
                    const className = blockModClassName(blockName, modName, modValue);

                    if (className) classList.push(className);
                });
            }

            if (Array.isArray(mix)) {
                mix.forEach((className) => {
                    if (className) classList.push(className);
                });
            }

            return classList.join(' ');
        } else if (isElemArgs(args)) {
            const [elemName, mix] = args;

            const classList = [elemClassName(blockName, elemName)];

            if (Array.isArray(mix)) {
                mix.forEach((className) => {
                    if (className) classList.push(className);
                });
            }

            return classList.join(' ');
        } else if (isElemModArgs(args)) {
            const [elemName, elemMods, mix] = args;

            const classList = [elemClassName(blockName, elemName)];

            if (elemMods) {
                Object.entries(elemMods).forEach(([modName, modValue]) => {
                    const className = elemModClassName(blockName, elemName, modName, modValue);

                    if (className) classList.push(className);
                });
            }

            if (Array.isArray(mix)) {
                mix.forEach((className) => {
                    if (className) classList.push(className);
                });
            }

            return classList.join(' ');
        }

        return blockName;
    };
